export default {
      id: "ar_services-usage",
      viewBox: "0 0 80 80",
      url: "../dist/images/" + "sprite.svg#ar_services-usage",
      toString: function () {
        return this.url;
      }
    }